import { DateTime } from 'luxon';

interface MemberIndividualHistoryResult {
  date: string;
  description: string;
  position: number | null | undefined;
  points: number | null | undefined;
}

interface MemberIndividualHistoryProps {
  history: MemberIndividualHistoryResult[] | null | undefined;
  descriptionLabel: string;
}

export default function MemberIndividualHistory({ history, descriptionLabel }: MemberIndividualHistoryProps) {
  if (!history || history.length === 0) {
    return null;
  }

  const record = history.map((result) => (
    <tr className={result.position === 1 ? 'highlight-win' : undefined} key={result.date}>
      <td>{DateTime.fromISO(result.date).year}</td>
      <td>{result.description}</td>
      <td>{result.position ? result.position : 'n/r'}</td>
      <td>{result.points ? result.points : 'n/r'}</td>
    </tr>
  ));

  return (
    <table className="table">
      <thead>
        <tr>
          <th>Year</th>
          <th>{descriptionLabel}</th>
          <th>Position</th>
          <th>Points</th>
        </tr>
      </thead>
      <tbody>{record}</tbody>
    </table>
  );
}
